import type { FC } from 'react';
import { useCallback } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import type { TimeRange } from '../types';

const TIME_RANGE_OPTIONS: { value: TimeRange; label: string }[] = [
  { value: 'today', label: 'Today' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_30_days', label: 'Last 30 days' },
];

interface TrendsTimeRangeFilterProps {
  value: TimeRange;
  onChange: (value: TimeRange) => void;
}

const TrendsTimeRangeFilter: FC<TrendsTimeRangeFilterProps> = ({ value, onChange }) => {
  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      onChange(event.target.value as TimeRange);
    },
    [onChange]
  );

  return (
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <InputLabel id="trends-time-range-label">Time range</InputLabel>
      <Select
        labelId="trends-time-range-label"
        id="trends-time-range"
        label="Time range"
        value={value}
        onChange={handleChange}
      >
        {TIME_RANGE_OPTIONS.map(({ value: optionValue, label }) => (
          <MenuItem key={optionValue} value={optionValue}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TrendsTimeRangeFilter;
